import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage } from 'react-intl';
import s from './CheckBox.css';

const CheckBox = ({ changeHandler, name, text, ...inputParams }) =>
  <label className={s.checkbox}>
    <input type="checkbox" name={name} onChange={changeHandler} {...inputParams} />{' '}
    <FormattedMessage id={text} />
  </label>;

CheckBox.propTypes = {
  text: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  changeHandler: PropTypes.func,
};

CheckBox.defaultProps = {
  changeHandler: () => {},
};

export default withStyles(s)(CheckBox);



// WEBPACK FOOTER //
// ./src/shared/components/UI/CheckBox/CheckBox.js